import React, { useMemo } from 'react';
import { Box, Step, StepLabel, Stepper, Typography } from '@mui/material';

export const ESTADO_LABELS = {
    pendiente_insumo: 'Insumo',
    en_asignacion: 'Asignación',
    asignada: 'Respuesta',
    con_turno: 'Con turno',
    pendiente_manual: 'Destrabar',
    cerrada: 'Cerrada',
    cancelada: 'Cancelada',
};

const FLOW_STEPS = [
    { key: 'pendiente_insumo', label: 'Insumo' },
    { key: 'en_asignacion', label: 'Asignación' },
    { key: 'asignada', label: 'Respuesta' },
    { key: 'con_turno', label: 'Turno' },
    { key: 'cerrada', label: 'Cierre' },
];

function activeIndex(estado, requiereInsumo) {
    if (estado === 'cancelada') return -1;
    if (estado === 'pendiente_manual') return 1;
    const keys = requiereInsumo
        ? FLOW_STEPS.map((s) => s.key)
        : FLOW_STEPS.filter((s) => s.key !== 'pendiente_insumo').map((s) => s.key);
    const idx = keys.indexOf(estado);
    if (idx >= 0) return idx;
    if (estado === 'cerrada') return keys.length - 1;
    return 0;
}

/**
 * Línea visual de pasos según estado de la orden.
 */
export default function OrdenTimeline({ estado, requiereInsumo = false, dense = false }) {
    const steps = useMemo(
        () => (requiereInsumo ? FLOW_STEPS : FLOW_STEPS.filter((s) => s.key !== 'pendiente_insumo')),
        [requiereInsumo]
    );

    const active = activeIndex(estado, requiereInsumo);
    const cancelled = estado === 'cancelada';
    const manual = estado === 'pendiente_manual';

    return (
        <Box sx={{ width: '100%', py: dense ? 0.5 : 1 }}>
            {cancelled ? (
                <Typography variant="body2" color="error" sx={{ fontWeight: 600 }}>
                    Orden cancelada
                </Typography>
            ) : null}
            {manual ? (
                <Typography variant="body2" color="warning.main" sx={{ fontWeight: 600, mb: 1 }}>
                    Requiere intervención manual (destrabar)
                </Typography>
            ) : null}
            <Stepper
                activeStep={cancelled ? -1 : active}
                alternativeLabel={!dense}
                orientation={dense ? 'vertical' : 'horizontal'}
            >
                {steps.map((step) => (
                    <Step key={step.key} completed={!cancelled && active > steps.findIndex((s) => s.key === step.key)}>
                        <StepLabel
                            error={manual && step.key === 'en_asignacion'}
                            optional={
                                estado === step.key ? (
                                    <Typography variant="caption" color="text.secondary">Actual</Typography>
                                ) : null
                            }
                        >
                            {step.label}
                        </StepLabel>
                    </Step>
                ))}
            </Stepper>
            {estado ? (
                <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
                    Estado: {ESTADO_LABELS[estado] || estado}
                </Typography>
            ) : null}
        </Box>
    );
}
